import AutoComplete from"./src/AutoComplete";if(!window.customElements.get("auto-complete")){window.customElements.define("auto-complete",AutoComplete)}